<template>
  <!-- The Modal -->
  <div
      id="editModal"
      class="modal"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <button
              type="button"
              class="close"
              data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <!-- Modal body -->
        <div class="">
          <!--Start-->
          <b-card-code
              title="Edit Portfolio"
          >
            <!-- form -->
            <validation-observer ref="simpleRules">
              <b-form>
                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <label for="name_en">Title «<span class="text-muted">English</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Title En"
                          rules="required"
                      >
                        <b-form-input
                            id="name_en"
                            v-model="updatedPortfolio.title"
                            name="name_en"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <label for="title_ar">Title «<span class="text-muted">Arabic</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Title Ar"
                          rules="required"
                      >
                        <b-form-input
                            id="title_ar"
                            v-model="updatedPortfolio.titleAR"
                            class="arabic-font"
                            name="title_ar"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                            :dir="'rtl'"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="content">Content «<span class="text-muted">English</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          name="content"
                          rules="required"
                      >
                        <template>
                          <b-form-textarea
                              id="content"
                              :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                              v-model="updatedPortfolio.content"
                              placeholder=""
                              rows="5"
                              cols="12"
                          />
                        </template>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="content_ar">Content «<span class="text-muted">Arabic</span>»</label>
                      <validation-provider
                          id="content_ar"
                          #default="{ errors }"
                          class="arabic-font"
                          name="content_ar"
                          rules="required"
                          :dir="'rtl'"
                      >
                        <template>
                          <b-form-textarea
                              id="textarea-default"
                              :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                              v-model="updatedPortfolio.contentAR"
                              placeholder=""
                              rows="5"
                              cols="12"
                          />
                        </template>

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="cover">Cover</label>
                      <validation-provider
                          id="cover"
                          #default="{ errors }"
                          name="cover"
                          rules=""
                      >
                        <vue-dropzone
                            id="image"
                            ref="portfolioDropzone"
                            name="image"
                            :options="dropzoneOptions"
                            style="/*display: flex!important;  padding: unset!important;*/"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                </b-row>
                <!-- Modal footer -->
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click.prevent="validationForm"
                  >
                    Submit
                  </button>
                </div>
              </b-form>
            </validation-observer>

            <template #code>
              {{ codeMultiple }}
            </template>
          </b-card-code>
          <!--End-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormTextarea,
} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import vue2Dropzone from 'vue2-dropzone'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import {codeMultiple, codeBasic} from './code'
import portfolioService from '@/services/porfolioService'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BFormTextarea,
    vueDropzone: vue2Dropzone,
  },
  props: ['portfolio'],
  data() {
    return {
      updatedPortfolio: {
        id: '',
        title: '',
        titleAR: '',
        content: '',
        contentAR: '',
        uploaded: [],
        remained: [],
      },
      emailValue: '',
      PasswordValue: '',
      passwordCon: '',
      required,
      password,
      email,
      confirmed,
      codeMultiple,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        addRemoveLinks: true,
        dictRemoveFile: 'Remove',
        acceptedFiles: ".jpeg,.jpg,.png,.gif",
      },
      edited_service: {name: '', description: ''},
      codeBasic,
    }
  },
  mounted() {
    this.$watch(() => this.portfolio, val => {
      this.$refs.portfolioDropzone.removeAllFiles()

      for (let i = 0; i < val.projectGallery.length; i++) {
        this.$refs.portfolioDropzone.manuallyAddFile(val.projectGallery[i].file, val.projectGallery[i].url)
        // this.$refs.portfolioDropzone.manuallyAddFile({...val.projectGallery[i].file, id: 3}, val.projectGallery[i].url)
      }
      /* Init Updated Object (Which will be sent To API) */
      this.updatedPortfolio = {
        id: val.id,
        title: val.title,
        titleAR: val.titleAR,
        content: val.content,
        contentAR: val.contentAR,
        uploaded: [],
        remained: [],
      }
    })
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          // eslint-disable-next-line
          const arr = this.$refs.portfolioDropzone.getRejectedFiles().map(el => el.id) ?? []
          console.log('Rejected Ids (the remain old files)', arr)

          this.updatedPortfolio.uploaded = this.$refs.portfolioDropzone.getAcceptedFiles() ?? []
          this.updatedPortfolio.remained = arr
          console.log('wow', this.updatedPortfolio)

          // this.updatedPortfolio.projectGallery = this.$refs.portfolioDropzone.getAcceptedFiles() ?? this.portfolio.projectGallery
          this.updatedPortfolio.projectGallery = this.$refs.portfolioDropzone.getAcceptedFiles().length > 0 ? this.$refs.portfolioDropzone.getAcceptedFiles() : this.portfolio.projectGallery
          portfolioService.put(this.updatedPortfolio).then(response => {
            if (response && response.status === 200) {
              this.$emit('refresh', 'true')

              // this.$refs.portfolioDropzone.removeAllFiles()

              $('#editModal').modal('hide')

              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Success',
                  icon: 'CheckIcon',
                  variant: 'success',
                  text: `Service Is Updated Successfully !`,
                },
              })
            }
            this.loading = false
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

label {
  font-weight: bold;
}
</style>
